import React from "react";
import InfoItem from "./InfoItem";
import { useTranslation } from "../../../context/TranslationContext";
const Info = () => {
  const {
    advInfo1Title,
    advInfo1Text,
    advInfo2Title,
    advInfo2Text,
    advInfo3Title,
    advInfo3Text,
    advInfo4Title,
    advInfo4Text,
    advInfo5Title,
    advInfo5Text,
  } = useTranslation();
  return (
    <ul className="grid gap-5 p-3 py-6 bg-white border rounded-md shadow-xl xl:p-8 lg:p-5 sm:grid-cols-2 lg:grid-cols-1 lg:gap-0">
      <InfoItem
        className={"bg-indigo-500"}
        IconName={"Wallet"}
        title={advInfo1Title}
        content={advInfo1Text}
      />
      <InfoItem
        className={"bg-green-600"}
        IconName={"Share"}
        title={advInfo2Title}
        content={advInfo2Text}
      />
      <InfoItem
        className={"bg-primary"}
        IconName={"Comment"}
        title={advInfo3Title}
        content={advInfo3Text}
      />
      <InfoItem
        className={"bg-orange"}
        IconName={"Camera"}
        title={advInfo4Title}
        content={advInfo4Text}
      />

      <InfoItem
        className={"bg-red-700"}
        IconName={"Team"}
        title={advInfo5Title}
        content={advInfo5Text}
      />
    </ul>
  );
};

export default Info;
